exports.createDragPreview = require('./lib/create-drag-preview')



//////////////////
// WEBPACK FOOTER
// ./~/react-dnd-text-dragpreview/index.js
// module id = 420
// module chunks = 0